import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { useComponentTheme, Slot } from '@costar-ui/components';
import { cn } from '@costar-ui/cosmos';
import React__default, { forwardRef, useMemo } from 'react';
import Caption from './caption.esm.js';

var _excluded = ["variant", "direction", "className", "testId", "children", "onClick", "responsive"];
// Define the PrivateInfoCard with a displayName
var PrivateInfoCard = /*#__PURE__*/forwardRef(function InfoCard(props, ref) {
  var theme = useComponentTheme('InfoCard');
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'default' : _props$variant,
    direction = props.direction,
    className = props.className,
    testId = props.testId,
    children = props.children,
    onClick = props.onClick,
    responsive = props.responsive,
    rest = _objectWithoutProperties(props, _excluded);
  var wrapperClasses = useMemo(function () {
    return theme.base({
      className: className,
      variant: variant
    });
  }, [theme, variant, className]);
  var interactiveClassName = useMemo(function () {
    return cn({
      'hover:cursor-pointer': onClick
    }, {
      'hover:cursor-pointer hover:shadow-elevation-20': variant === 'default' && onClick
    }, responsive ? 'flex-wrap' : '');
  }, [onClick, responsive, variant]);
  return /*#__PURE__*/React__default.createElement(Slot, _extends({
    as: "figure",
    ref: ref,
    direction: direction,
    className: "csg-tw-info-card ".concat(wrapperClasses, " ").concat(interactiveClassName),
    onClick: onClick,
    testId: testId
  }, rest), children);
});
PrivateInfoCard.displayName = 'PrivateInfoCard';
var InfoCard = Object.assign(PrivateInfoCard, {
  Caption: Caption
});
var ForwardedInfoCard = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(InfoCard, _extends({
    ref: ref
  }, props));
});
ForwardedInfoCard.displayName = 'InfoCard';
InfoCard.displayName = 'InfoCard';
var InfoCard$1 = InfoCard;

export { InfoCard$1 as default };
//# sourceMappingURL=info-card.esm.js.map
